import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src755878744/src/bacha-ai-frontend/components/ProductCards.tsx");
